import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Users } from '../../classes/users.interface';
import { NgForm } from '@angular/forms';
import {Http, Response, Request, Headers} from '@angular/http';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { AuthService } from '../../authentication/auth.service';
import { CartService } from '../../services/cart.service';
import { Billing } from '../../classes/billing';
import { Shipping } from '../../classes/shipping';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UpdateprofileComponent } from '../../usersettings/updateprofile/updateprofile.component';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { PasswordresetComponent} from '../../usersettings/passwordreset/passwordreset.component';
import { VerifymobileComponent} from '../../usersettings/verifymobile/verifymobile.component';
import { MitterService } from '../../services/mitter.service';
@Component({
  selector: 'app-manageprofile',
  templateUrl: './manageprofile.component.html',
  styleUrls: ['./manageprofile.component.css']
})
export class ManageprofileComponent implements OnInit {
  flag: number;
  vflag = 0;
  u: Users[];
  i: string;
  bid: any;
  action: any;
  ssid: any;
  sid: number;
  selectedOption: any;
  msg: string;
  manageprofileform: any;
  filename: string;
  umobile: any;
  uemail: any;
  uname: any;
  uid: any;
  users: Users[];
  isdefault = 0;
  uploadFile: any;
  hasBaseDropZoneOver = false;
  options: Object = {
  url : 'https://passport.petcart.in/images/userimgs/index.php'
  };
  sizeLimit = 2000000;
 public loading = false;
 reload: true;
  constructor(private commonService: CommonService, private doctorService: DoctorService,
     public form: FormBuilder, private authService: AuthService, private mitterService: MitterService,
     private cartService: CartService, public dialog: MatDialog,
    private snackBar: MatSnackBar, private router: Router) {
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
    this.uname = udata.uname;
    this.uemail = udata.uemail;
    this.umobile = udata.umobile;
    this.manageprofileform = this.form.group({
      "name": new FormControl("",Validators.required),
      "mobile": new FormControl("",[Validators.required,Validators.minLength(10)]),
      "password": new FormControl("",[Validators.required]),
      "cnfmPass": new FormControl ("", [Validators.required,this.equalto('password')]),
      "billAdd1": new FormControl ("",Validators.required),
      "billAdd2": new FormControl ("",Validators.required)
      });
      this.commonService.petflagvalue.subscribe(flag => {
        this.flag = flag ;
    });
   }

  ngOnInit() {
   // this.getImage();
   this.loading = true;
    this.getParticularUser();
    console.log('in manageprofile');
  }
  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
    let input = control.value;
    let isValid = control.root.value[field_name] === input
// Add a comment to this line
    if (!isValid){
    return { 'equalTo': {isValid} }
    } else {
    return null;
    }
    };
  }
  updateUserName() {
    this.commonService.updateUserName(this.uid, this.manageprofileform.name, this.manageprofileform.mobile, this.manageprofileform.password)
    .subscribe(
      (x: Users[]) => {
      this.users = x;
      });
  }


      getParticularUser() {
        this.commonService.getParticularUser(this.uid)
        .subscribe(
          (x) => {
            this.loading = false;
            this.users = x;
            if (x[0].verified === 'v') {
              this.vflag = 1;
            }
          });
      }


      uploadImage(file) {
        this.loading = true;
        this.commonService.updateimage(this.uid, file )
        .subscribe(
          (x: Users[] ) => {
            this.loading = false;
            console.log('in manageprofile');
            this.msg = "Image Uploaded Successfully";
            this.openSnackBar();
            this.users[0].image = file;
          });
      }

      openDialog(name, mobile, bio) {
        const dialogRef = this.dialog.open(UpdateprofileComponent, {
          width: '400px',
          height: '400px',
          data: {name: name, mobile: mobile, bio: bio}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result === 1) {
            this.getParticularUser();
          }
        });
      }
      open(id) {
          this.sid = id;
      }
 openSnackBar() {
          this.snackBar.open(this.msg , this.action, {
            duration: 4000,
          });
        }

/* for file upload*/

          handleUpload(data): void {
          if (data && data.response) {
              data = JSON.parse(data.response);
              this.uploadFile = data;
              this.filename = data.originalName;
              this.uploadImage(this.filename);
           }
         
          }

          fileOverBase(e: any): void {
            this.hasBaseDropZoneOver = e;
          }

          beforeUpload(uploadingFile): void  {
            if (uploadingFile.size >  this.sizeLimit) {
              uploadingFile.setAbort();
              alert('File is too large');
            }
          }
          changepassword() {
            const dialogRef = this.dialog.open( PasswordresetComponent, {
              width: '500px',
              height: '500px',
              data: {email: this.uemail, uid: this.uid}
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result === 1) {
              }
            });
          }

          verifyMobile() {
            const otp = this.getRandomArbitrary(1000, 9000);
            this.loading = true;
            this.commonService.createOtp(this.users[0].id, otp)
            .subscribe(
               (x) => {
                 this.loading = false;
                this.commonService.sendOtp(this.uname, this.umobile, otp);
                this.openOtpForm();
              }
            );
          }

          getRandomArbitrary(min, max) {
            const num = min + Math.random() * max;
           return Math.trunc(num);
        }
        openOtpForm() {
          const dialogRef = this.dialog.open(VerifymobileComponent, {
            width: '400px',
            height: '400px',
            data: {uid: this.users[0].id}
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 1) {
              this.vflag = 1;
            }
          });
        }

        logOut() {
          this.authService.logout();
          this.mitterService.logout();
          this.router.navigate(['/signin']);
        }
}







